import { NavigationExtras } from '@angular/router';

export interface SimpleRouterNavigationExtras extends NavigationExtras {
  clearNotifications?: boolean;
  autostartPage?: boolean;
}
